import React from "react"
import styles from "./Skeleton.module.scss"
import cn from "classnames"

export interface AdvancedSkeletonProps {
    count?: number
    style?: React.CSSProperties
    className?: string
    loadingText?: string
}

const AdvancedSkeleton: React.FC<AdvancedSkeletonProps> = props => {
    const { count, style, className } = props

    return (
        <div className={styles.container}>
            {props.loadingText && <div className={styles.container__loadingText}>{props.loadingText}</div>}
            {Array.from({ length: count || 1 }, (_, index) => (
                <div key={index} style={{ ...style }}>
                    <div className={cn(styles.container__skeleton, className && className)} />
                </div>
            ))}
        </div>
    )
}

export default AdvancedSkeleton
